import { render, staticRenderFns } from "./UserVerified.vue?vue&type=template&id=153df032&scoped=true"
import script from "./UserVerified.vue?vue&type=script&lang=js"
export * from "./UserVerified.vue?vue&type=script&lang=js"
import style0 from "./UserVerified.vue?vue&type=style&index=0&id=153df032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153df032",
  null
  
)

export default component.exports